import styled from 'styled-components';

import { mediaConfined, mediaWide } from '@xingternal/layout-tokens';
import { space3XL, spaceL, spaceS, spaceXXL, xdlColorTextSecondary } from '@xingternal/tokens';
import { BodyCopy, Headline } from '@xingternal/typography';
import { Column, Row } from '@xingternal/xing-grid';

export const InfoTitle = styled(Headline)`
  color: ${xdlColorTextSecondary};
  margin-bottom: ${spaceS};
`;

export const InfoText = styled(BodyCopy)`
  color: ${xdlColorTextSecondary};
  margin-bottom: ${spaceL};
`;

export const ButtonWrapper = styled(Row)`
  margin-bottom: 20px;
`;

export const Info = styled(Column)`
  text-align: center;
  padding: calc(${spaceXXL} * 2) 0;

  @media ${mediaConfined} {
    padding-top: ${space3XL};
  }

  @media ${mediaWide} {
    padding-top: calc(${space3XL} * 2);
  }
`;

export const ImageWrapper = styled.div`
  margin-bottom: ${spaceL};
`;
